module.exports = __webpack_public_path__ + "media/images/sp/articles/report_deco-5a740abfd00913d468a7397cd16df054.webp";